import { DOCUMENTS_OPTIONS } from '../../../constraints';

export const parseDocumentTypeList = (documentStatusList) => {
  const value = documentStatusList?.value;
  if (value === DOCUMENTS_OPTIONS.ALL) {
    return undefined;
  }
  return value;
};
